import Array_Sort_Numbers from './Array_Sort_Numbers';

const Quartile = (data, q) => {
  data = Array_Sort_Numbers(data.concat());

  let pos = ((data.length) - 1) * q;
  let base = Math.floor(pos);
  let rest = pos - base;

  if( (data[base+1]!==undefined) ) {
    return data[base] + rest * (data[base+1] - data[base]);
  } else {
    return data[base];
  }
}

export default Quartile;


